import axiosConfig from "./axiosConfig";

const eventsAPI = {};

eventsAPI.getUpcomingEvents = () =>
  axiosConfig.get(`/api/events/?upcoming=1&limit=100`);
eventsAPI.getEvents = () => axiosConfig.get(`/api/events/`);
eventsAPI.get = (id) => axiosConfig.get(`/api/events/${id}/`);
eventsAPI.assignSong = (data) => axiosConfig.post(`/api/assign-event/`, data);
eventsAPI.patchEvent = (eventId, data) =>
  axiosConfig.patch(`/api/events/${eventId}/`, data);
eventsAPI.createEvent = (data) => axiosConfig.post(`/api/events/`, data);
eventsAPI.deleteEvent = (eventId) =>
  axiosConfig.delete(`/api/events/${eventId}/`);
eventsAPI.reorderItems = (eventId, items) =>
  axiosConfig.patch(`/api/events/${eventId}/reorder-items/`, { items });
eventsAPI.addSong = (eventId, songId, sectionId) =>
  axiosConfig.post(`/api/events/${eventId}/add-song/`, { song: songId, section: sectionId });
eventsAPI.addNote = (eventId, content, sectionId) =>
  axiosConfig.post(`/api/events/${eventId}/add-note/`, { content, section: sectionId });
eventsAPI.updateNote = (eventId, noteId, content) =>
  axiosConfig.patch(`/api/events/${eventId}/notes/${noteId}/`, { content });
eventsAPI.deleteNote = (eventId, noteId) =>
  axiosConfig.delete(`/api/events/${eventId}/notes/${noteId}/`);
eventsAPI.notifyTeam = (eventId) =>
  axiosConfig.post(`/api/events/${eventId}/notify/`);

export default eventsAPI;
